import React, { useEffect, useRef } from 'react';
import { PixelRatio, StyleProp, StyleSheet, Text, TextStyle, TouchableHighlight, View, ViewStyle } from 'react-native';
import Game from '../shell/Game';
import { Option } from '../shell/Questions';
import useFontSize from '../shell/hooks/useFontSize';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { selectAdvance, setAdvance } from '../store/slices/AdvanceSlice';
import { TquestionFormat, selectGameObject, setQuestionAnswer } from '../store/slices/gameObjectSlice';

interface TQuestionProps {
    questionObj?: TquestionFormat,
    questionStyle?: StyleProp<ViewStyle>,
    buttonsText?: StyleProp<TextStyle>,
}
export const TQuestion: React.FC<TQuestionProps> = React.memo(({ questionObj, buttonsText, questionStyle }) => {

    const gameObject = useAppSelector(selectGameObject);
    const advance = useAppSelector(selectAdvance);
    const questionRef = (questionObj?.question || gameObject.present.question);
    const saveIndex = useRef(0);

    const dispatch = useAppDispatch();

    const { title, displayQuestion, options: answers } = questionRef;
    const questionsColor = `#009688`;
    const styles = StyleSheet.create({
        question: {
            height: "100%",
            flex: 2,
            flexGrow: 1,
            alignItems: "stretch",
        },
        buttons: {
            flex: 1,
            flexGrow: 1,
            alignItems: "stretch",
            elevation: 8,
            backgroundColor: questionsColor,
            borderRadius: 2,
            paddingVertical: 5 / PixelRatio.get(),
            paddingHorizontal: 12 / PixelRatio.get(),
            margin: 1 / PixelRatio.get(),
            opacity: 0.9,
            zIndex: 1500,
            justifyContent: "center",
            display: "flex",
        },
        buttonsText: {
            alignItems: "stretch",
            flexShrink: 1,
            margin: "auto",
            marginLeft: 0,
            fontSize: useFontSize(1.5),
            color: "#fff",
            fontWeight: "bold",
            textTransform: "uppercase"
        }
    });

    useEffect(() => {
        if (displayQuestion && !Game.rollback && !Game.isReplayRunning) {
            // TODO: disabling this for now because it causes weird flickering sometimes that I don't like
            // setTimeout(() => {
            //     _doSave({ customName: '', folder: "default", page: "A", slot: saveIndex.current, timestamp: new Date() }, saveIndex.current, '').then(res => {
            //         saveIndex.current = (saveIndex.current + 1) % 12;
            //     });

            // }, 50);
        }

    }, [displayQuestion]);


    const handleOnClick = async (value: Option) => {
        dispatch(setAdvance({ canAdvance: true, promise: true }));
        dispatch(setQuestionAnswer({ ...value, titleKey: questionRef.title.key }));



    };
    function renderQuestion(answer: Option) {
        if (answer.hide || !answer.show) { return (<React.Fragment key={answer.title + answer.key}></React.Fragment>); }
        return (
            <TouchableHighlight disabled={answer.disabled} key={answer.title + answer.key} style={[styles.buttons, { backgroundColor: answer.disabled ? "#808080" : questionsColor }]} onPress={() => handleOnClick(answer)}>
                <>
                    <Text style={[buttonsText || styles.buttonsText]}>{answer.title} </Text>
                    <Text style={{ position: "relative", }}>{answer.info}</Text>
                </>
            </TouchableHighlight>
        );
    }


    return (
        <>
            {/* TODO: text question for android sometime too big example: V5ChrisRandomGirlTalk2 */}
            {displayQuestion ?
                <View style={[questionStyle || styles.question]}>
                    {answers ? answers.map((answer: Option) =>
                    (
                        renderQuestion(answer)
                    )
                    ) : <></>}
                </View>

                : <View style={[questionStyle || styles.question]}></View>}
        </>
    );
});

export default TQuestion;
